<template>
  <div class="repres__reports" id="represReports">
    <div class="repres__reports-top">
      <base-input
        v-model="CustomerNo"
        inputType="number"
        labelText="Müşteri Numarası"
        class="customerNoInput"
      />
      <div class="form-group">
        <label for="startDate" class="form-control-label"
          >Başlangıç Tarihi</label
        >
        <date-picker
          v-model="startDate"
          id="startDate"
          valueType="format"
          format="DD/MM/YYYY"
          :clearable="false"
        ></date-picker>
      </div>
      <div class="form-group">
        <label for="endDate" class="form-control-label">Bitiş Tarihi</label>
        <date-picker v-if="startDate == null" :disabled="true"></date-picker>
        <date-picker
          v-else
          v-model="endDate"
          id="endDate"
          :disabledDate="disabledBeforeStartDate"
          valueType="format"
          format="DD/MM/YYYY"
          :clearable="false"
        ></date-picker>
      </div>
      <div class="form-group">
        <base-button
          @click="show"
          id="show"
          :class="isButtonClicked ? 'no-click' : ''"
          class="showAll"
          >{{ !dataIsLoading ? "Uygula" : "Yükleniyor..." }}</base-button
        >
      </div>
      <div class="form-group">
        <base-button @click="clear" id="clear" class="clear-button"
          >Temizle</base-button
        >
      </div>
      <div class="form-group">
        <div @click="showModal()" class="more" id="more">
          Detaylı Filtreleme
        </div>
      </div>
      <div v-if="dataIsLoading || excelIsLoading" class="loader">
        <div class="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>

    <div class="repres__reports-result" :class="dataIsLoading ? 'hideAll' : ''">
      <div
        :class="excelIsLoading ? 'no-click' : ''"
        @click="downloadExcel"
        class="exportButton"
        v-if="
          representativeReport.data &&
          representativeReport.data.length > 0 &&
          !excelIsLoading
        "
      >
        <base-icon
          v-if="!excelIsLoading"
          class="downloadExcel"
          name="excel-export"
        />
        {{ !excelIsLoading ? "Excel’le Dışa Aktar" : "Yükleniyor..." }}
      </div>
      <table
        aria-describedby="represTable"
        v-if="representativeReport.data && representativeReport.data.length > 0"
      >
        <thead>
          <tr>
            <th scope="col">Müşteri No</th>
            <th scope="col">Ad Soyad</th>
            <th scope="col">Vendor</th>
            <th scope="col">Paket</th>
            <th scope="col">Ürün</th>
            <th scope="col">Platform</th>
            <th scope="col">Tutar</th>
            <th scope="col">Temsilci</th>
            <th scope="col">Kazandıran</th>
            <th scope="col">Durum</th>
            <th scope="col">Masraf Ödeme Durumu</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in representativeReport.data" :key="index">
            <td :title="item.customerNo" :alt="item.customerNo">
              {{ item.customerNo }}
            </td>
            <td :title="item.customerFullName" :alt="item.customerFullName">
              {{ item.customerFullName }}
            </td>
            <td :title="item.vendor" :alt="item.vendor">{{ item.vendor }}</td>
            <td :title="item.market" :alt="item.market">{{ item.market }}</td>
            <td :title="item.product" :alt="item.product">
              {{ item.product }}
            </td>
            <td :title="item.platform" :alt="item.platform">
              {{ item.platform }}
            </td>
            <td
              :title="
                item.price +
                (item.priceType == '₺'
                  ? 'TL'
                  : '' + item.priceType == '$'
                  ? 'USD'
                  : '' + item.priceType == '€'
                  ? 'EUR'
                  : '')
              "
            >
              {{ item.price }}
              <span v-if="item.priceType === '₺'">TL</span>
              <span v-if="item.priceType === '€'">EUR</span>
              <span v-if="item.priceType === '$'">USD</span>
            </td>
            <td :title="item.representativeName">
              {{ item.representativeName }}
            </td>
            <td :title="item.earning">{{ item.earning }}</td>
            <td :title="item.status">{{ item.status }}</td>
            <td :title="item.paymentStatus">{{ item.paymentStatus }}</td>
          </tr>
        </tbody>
      </table>
      <table aria-describedby="represTableEmpty" v-else>
        <thead>
          <tr>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <td>Aradığınız kriterde sonuç bulunamadı..</td>
        </tbody>
      </table>
    </div>
    <div v-if="tableLoader">
      <div class="loader">
        <div class="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
    <repres-reports-pager
      v-if="representativeReport.page && !tableLoader"
      :pageNumber="
        representativeReport.page.pageNumber
          ? representativeReport.page.pageNumber
          : 0
      "
      :pageSize="
        representativeReport.page.pageSize
          ? representativeReport.page.pageSize
          : 0
      "
      :totalItems="
        representativeReport.page.totalElements
          ? representativeReport.page.totalElements
          : 0
      "
      @onPageChanged="checkedChangedData"
    />

    <modal
      height="auto"
      class="modal"
      :name="'modal'"
      @opened="handleModalOpen"
    >
      <div class="modal-heading">
        <div class="modal-title">
          <h5>Müşteri Raporları</h5>
        </div>
        <a @click="hideModalFromButtons">
          <base-icon class="close" name="close-circle" />
        </a>
      </div>
      <div class="modal-body">
        <div class="row">
          <div
            class="col"
            :class="{ lowOpacity: isLowOpacity(CustomerNo) }"
            @click="handleClick($event, 'CustomerNo')"
          >
            <base-input
              v-model="CustomerNo"
              inputType="number"
              labelText="Müşteri Numarası"
              ref="CustomerNo"
            />
          </div>
          <div
            class="col"
            :class="{ lowOpacity: isLowOpacity(CustomerName) }"
            @click="handleClick($event, 'CustomerName')"
          >
            <base-input
              v-model="CustomerName"
              inputType="text"
              labelText="Ad Soyad"
              ref="CustomerName"
            />
          </div>
          <div
            class="col"
            :class="{ lowOpacity: isLowOpacity(startDate) }"
            @click="handleClick($event, 'startDate')"
          >
            <label for="startDateModal" class="form-control-label"
              >Başlangıç Tarihi</label
            >
            <date-picker
              v-model="startDate"
              id="startDateModal"
              valueType="format"
              format="DD/MM/YYYY"
              ref="startDate"
            ></date-picker>
          </div>
        </div>
        <div class="row">
          <div
            class="col"
            :class="{ lowOpacity: isLowOpacity(endDate) }"
            @click="handleClick($event, 'endDate')"
          >
            <label for="endDateModal" class="form-control-label"
              >Bitiş Tarihi</label
            >
            <date-picker
              v-if="startDate == null"
              :disabled="true"
              ref="endDate"
            ></date-picker>
            <date-picker
              v-else
              v-model="endDate"
              id="endDateModal"
              :default-value="new Date()"
              :disabledDate="disabledBeforeStartDate"
              valueType="format"
              format="DD/MM/YYYY"
              ref="endDate"
            ></date-picker>
          </div>
          <div
            class="col"
            :class="{ lowOpacity: isLowOpacity(Applications) }"
            @click="handleClick($event, 'Applications')"
          >
            <BaseSelect
              v-model="Applications"
              @change="changeApplications"
              :selectedId="Applications === '' ? defaultSelected : Applications"
              fieldLabel="İşlem Platformu"
              id="Applications"
              :options="vendor"
              placeholder="Tümü"
              :clearable="false"
              :class="{ lowOpacity: Applications == '' }"
              ref="Applications"
            />
          </div>
          <div
            class="col"
            :class="{ lowOpacity: isLowOpacity(Platforms) }"
            @click="handleClick($event, 'Platforms')"
          >
            <BaseSelect
              v-model="Platforms"
              @change="changePlatforms"
              :selectedId="Platforms === '' ? defaultSelected : Platforms"
              fieldLabel="Platform"
              id="platform"
              :options="platform"
              placeholder="Tümü"
              :clearable="false"
              ref="Platforms"
            />
          </div>
        </div>
        <div class="row">
          <div
            class="col"
            :class="{ lowOpacity: isLowOpacity(Markets) }"
            @click="handleClick($event, 'Markets')"
          >
            <BaseSelect
              v-model="Markets"
              @change="changeMarketList"
              :selectedId="Markets === '' ? defaultSelected : Markets"
              fieldLabel="Paket Adı"
              id="marketsList"
              :options="marketsList"
              placeholder="Tümü"
              :clearable="false"
              :multiple="false"
              ref="Markets"
            />
          </div>
          <div
            class="col"
            :class="{ lowOpacity: isLowOpacity(PerspectiveOrVendor) }"
            @click="handleClick($event, 'PerspectiveOrVendor')"
          >
            <BaseSelect
              v-model="PerspectiveOrVendor"
              @change="changeVendor"
              :selectedId="
                PerspectiveOrVendor === ''
                  ? defaultSelected
                  : PerspectiveOrVendor
              "
              fieldLabel="Ürün"
              id="vendor"
              :options="perspectives"
              placeholder="Tümü"
              :clearable="false"
              ref="PerspectiveOrVendor"
            />
          </div>
          <div
            class="col"
            :class="{ lowOpacity: isLowOpacity(PackageStatus) }"
            @click="handleClick($event, 'PackageStatus')"
          >
            <BaseSelect
              v-model="PackageStatus"
              @change="changePackageStatus"
              :selectedId="
                PackageStatus === '' ? defaultSelected : PackageStatus
              "
              fieldLabel="Durum"
              id="filter"
              :options="statu"
              placeholder="Tümü"
              :clearable="false"
              ref="PackageStatus"
            />
          </div>
        </div>
        <div class="row">
          <div
            class="col"
            :class="{ lowOpacity: isLowOpacity(Algorithms) }"
            @click="handleClick($event, 'Algorithms')"
          >
            <BaseSelect
              v-model="Algorithms"
              @change="changeAlgo"
              :selectedId="Algorithms === '' ? defaultSelected : Algorithms"
              fieldLabel="Algoritmalar"
              id="AlgorithmsList"
              :options="algoList"
              placeholder="Tümü"
              :clearable="false"
              :multiple="false"
              ref="Algorithms"
            />
          </div>
          <div
            class="col"
            :class="{ lowOpacity: isLowOpacity(Foreigns) }"
            @click="handleClick($event, 'Foreigns')"
          >
            <BaseSelect
              v-model="Foreigns"
              @change="changeForeign"
              :selectedId="Foreigns === '' ? defaultSelected : Foreigns"
              fieldLabel="Yabancı Endeskler"
              id="Foreigns"
              :options="foreignList"
              placeholder="Tümü"
              :clearable="false"
              ref="Foreigns"
            />
          </div>
          <div
            class="col"
            :class="{ lowOpacity: isLowOpacity(Researches) }"
            @click="handleClick($event, 'Researches')"
          >
            <BaseSelect
              v-model="Researches"
              @change="changeResearch"
              :selectedId="Researches === '' ? defaultSelected : Researches"
              fieldLabel="Araştırma vd."
              id="filter"
              :options="researchList"
              placeholder="Tümü"
              :clearable="false"
              ref="Researches"
            />
          </div>
        </div>
        <div class="row" :class="Branch.length >= 2 ? 'tripple' : ''">
          <div
            class="col"
            :class="{ lowOpacity: isLowOpacity(PaymentStatus) }"
            @click="handleClick($event, 'PaymentStatus')"
          >
            <BaseSelect
              v-model="PaymentStatus"
              @change="changePaymentStatus"
              :selectedId="
                PaymentStatus === '' ? defaultSelected : PaymentStatus
              "
              fieldLabel="Masraf Ödeme Durumu"
              id="filteredPaymentStatus"
              :options="paymentStatusList"
              :placeholder="'Tümü'"
              :clearable="false"
              ref="PaymentStatus"
            />
          </div>
          <div class="col" v-if="BranchList.length">
            <label class="form-control-label"
              >Şube (Max 3) -
              <span>Seçilebilir: {{ 3 - Branch.length }}</span></label
            >
            <vue-select
              multiple="multiple"
              :tripleChecked="Branch.length > 3 ? true : false"
              :options="BranchList"
              class="branch-selectbox v-select veri-dagitim-selectbox"
              :class="Branch.length > 0 ? 'hasItem' : ''"
              v-model="Branch"
              @input="changeBranch($event)"
              placeholder="Şube Seçiniz"
              :deselectFromDropdown="true"
              :disabled="isWinner"
            >
              <span class="checkbox-label" slot="option" slot-scope="scope">
                <input class="test" type="checkbox" :checked="scope.checked" />
                {{ scope.label }}
              </span>
              <span slot="no-options">Sonuç bulunamadı..</span>
            </vue-select>
            <div class="toggleBranch" @click="isWinner = !isWinner">
              <span>
                <input type="checkbox" :checked="isWinner" />
              </span>
              <span> Kazandıranı olduğum müşteriler </span>
            </div>
          </div>
          <div v-else class="col"></div>
          <div class="col" v-if="Branch.length < 2"></div>
        </div>
      </div>
      <div class="modal-bottom">
        <base-button class="giveUp" @click="hideModalFromButtons"
          >Vazgeç</base-button
        >
        <base-button
          @click="clearModal"
          id="clear"
          class="red-button clear-button"
          >Temizle</base-button
        >
        <base-button class="show" @click="show">Uygula</base-button>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import VueSelect from "vue-select";
import { BaseInput, BaseButton, BaseIcon, BaseSelect } from "@/components";

import RepresReportsPager from "../components/base/RepresReportsPager.vue";

export default {
  name: "RepresReports",
  components: {
    VueSelect,
    BaseInput,
    BaseButton,
    BaseIcon,
    BaseSelect,
    RepresReportsPager,
  },

  mounted() {
    this.clearReports();
    this.getBranchListForFilter().then(() => {
      this.BranchList = this.getBranchList;
    });
    this.$nextTick(() => {
      setTimeout(() => {
        this.applyLowOpacityClass();
      }, 300);
    });
  },

  data() {
    return {
      excelIsLoading: false,
      dataIsLoading: false,
      tableLoader: false,
      platform: [],
      statu: [],
      vendor: [],
      perspectives: [],
      paymentStatusList: [],
      researchList: [],
      algoList: [],
      foreignList: [],
      marketsList: [],
      dateFilter: "",
      CustomerNo: "",
      CustomerName: "",
      DatePeriod: "",
      Applications: "",
      PerspectiveOrVendor: "",
      PackageStatus: "",
      Platforms: "",
      PaymentStatus: "-1",
      Algorithms: "",
      Foreigns: "",
      Researches: "",
      Markets: "",
      isButtonClicked: false,
      startDate: null,
      endDate: null,
      Branch: [],
      BranchList: [],
      isWinner: false,
      filtered: {
        Markets: "",
        Applications: "",
        PerspectiveOrVendor: "",
        Platforms: "",
        Status: "",
        PaymentStatus: "",
        Researchs: "",
        Algorithms: "",
        ForeignIndices: "",
        isWinner: false,
      },
      defaultSelected: -1,
      key: 0,
      xlsxData: {
        columns: [
          {
            label: "Müşteri Numarası",
            field: "customerNo",
          },
          {
            label: "Ad Soyad",
            field: "customerFullName",
          },
          {
            label: "İşlem Platformu",
            field: "vendor",
          },
          {
            label: "Paket",
            field: "market",
          },
          {
            label: "Ürün",
            field: "product",
          },
          {
            label: "Platform",
            field: "platform",
          },
          {
            label: "Tutar",
            field: "price",
          },
          {
            label: "Temsilci",
            field: "representativeName",
          },
          {
            label: "Kazandıran",
            field: "earning",
          },
          {
            label: "Durum",
            field: "status",
          },
          {
            label: "Masraf Ödeme Durumu",
            field: "paymentStatus",
          },
        ],
        data: [],
      },
      xlsxDownloadableUrl: "",
    };
  },

  computed: {
    ...mapGetters([
      "getFilterList",
      "getFilterData",
      "representativeReport",
      "getBranchList",
    ]),
  },

  methods: {
    ...mapActions([
      "fillFilter",
      "getRepresentativeReport",
      "getRepresExportAction",
      "clearReports",
      "getBranchListForFilter",
    ]),
    ...mapMutations([
      "setFilter",
      "setGeneralFilter",
      "setRepresentativeReport",
    ]),
    applyLowOpacityClass() {
      const models = [
        "CustomerNo",
        "CustomerName",
        "startDate",
        "Applications",
        "Platforms",
        "Markets",
        "PerspectiveOrVendor",
        "PackageStatus",
        "Algorithms",
        "Foreigns",
        "Researches",
        "PaymentStatus",
        "Branch",
      ];
      models.forEach((model) => {
        if (this[model] == null || this[model] === "") {
          if (this.$refs[model] && this.$refs[model].$el) {
            this.$refs[model].$el.classList.add("lowOpacity");
          } else if (this.$refs[model]) {
            this.$refs[model].classList.add("lowOpacity");
          }
        }
      });
    },
    isLowOpacity(model) {
      return model == null || model === "" || model == "-1";
    },
    handleModalOpen() {
      this.$nextTick(() => {
        this.applyLowOpacityClass();
      });
    },
    handleClick(event, model) {
      const target = event.currentTarget;
      if (
        this[model] == null ||
        this[model] === "" ||
        this[model] === -1 ||
        this[model] === "-1"
      ) {
        target.classList.remove("lowOpacity");
      }
      const input = target.querySelector("input, select, textarea");
      if (input) {
        input.focus();
        input.addEventListener("blur", () => {
          if (
            this[model] == null ||
            this[model] === "" ||
            this[model] === -1 ||
            this[model] === "-1"
          ) {
            target.classList.add("lowOpacity");
          }
        });
      }
    },
    checkedChangedData(selectedPage) {
      this.setGeneralFilter({ page: selectedPage, size: Number(11) });
      this.tableLoader = true;
      this.isButtonClicked = true;
      this.getRepresentativeReport((response) => {
        this.xlsxData.data = response.data;
        if (response.error) {
          this.$toast.error(response.message);
        }
        this.isButtonClicked = false;
        this.tableLoader = false;
      });
    },
    changeDateFilter(value) {
      let concatValue = value[0] + "&" + value[1];
      if (concatValue != ["null&null"]) {
        this.DatePeriod = concatValue;
      } else {
        this.DatePeriod = "";
      }
    },
    changeBranch($event) {
      if ($event.length > 3) {
        $event.pop();
      }
      if ($event.length) {
        this.BranchList.forEach((element) => {
          const isInEvent = $event.some(
            (selectedItem) => selectedItem.code === element.code
          );
          if (!isInEvent) {
            element.checked = false;
          }
        });

        $event.forEach((selectedItem) => {
          this.BranchList.forEach((element) => {
            if (selectedItem.code === element.code) {
              element.checked = true;
            }
          });
        });

        this.BranchList.sort((a, b) => {
          if (a.checked && !b.checked) {
            return -1;
          } else if (!a.checked && b.checked) {
            return 1;
          } else {
            return 0;
          }
        });
      } else {
        this.BranchList.forEach((element) => {
          element.checked = false;
        });
        this.BranchList.sort((a, b) => a.label.localeCompare(b.label));
      }
    },
    disabledBeforeStartDate(date) {
      const formatNewType = (date) => {
        const day = date.split("/")[0];
        const month = date.split("/")[1];
        const year = date.split("/")[2];
        return new Date(year, month - 1, day);
      };
      const lastResult = formatNewType(this.startDate);
      return date <= lastResult;
    },
    downloadExcel() {
      if (this.excelIsLoading) return;
      this.excelIsLoading = true;
      this.isButtonClicked = true;
      this.getRepresExportAction((response) => {
        this.excelIsLoading = false;

        this.xlsxDownloadableUrl = `${process.env.VUE_APP_API_URL}/${response}`;
        window.open(this.xlsxDownloadableUrl);
        if (response.error) {
          this.$toast.error(response.message);
        }
        this.isButtonClicked = false;
      });
    },
    changeVendor(value) {
      this.PerspectiveOrVendor = value?.label;
    },

    changePackageStatus(value) {
      this.PackageStatus = value?.label;
    },
    changePaymentStatus(value) {
      this.PaymentStatus = value?.label;
    },
    changeAlgo(value) {
      this.Algorithms = value?.label;
    },
    changeResearch(value) {
      this.Researches = value?.label;
    },
    changeForeign(value) {
      this.Foreigns = value?.label;
    },
    changeMarketList(value) {
      this.Markets = value?.label;
    },
    changeApplications(value) {
      this.Applications = value?.label;
    },
    changePlatforms(value) {
      this.Platforms = value?.label;
    },
    showModal() {
      this.getFilter();
      this.$modal.show("modal");
    },
    getFilter() {
      this.fillFilter().then((res) => {
        if (res.data) {
          const vendors = this.getFilterList.filter(
            (o) => o.name === "Applications"
          );
          const platforms = this.getFilterList.filter(
            (o) => o.name === "Platforms"
          );
          const markets = this.getFilterList.filter(
            (o) => o.name === "Markets"
          );
          const perspectives = this.getFilterList.filter(
            (o) => o.name === "Perspectives"
          );
          const paymentStatus = this.getFilterList.filter(
            (o) => o.name === "PaymentStatus"
          );
          const researchs = this.getFilterList.filter(
            (o) => o.name === "Researchs"
          );
          const algorithms = this.getFilterList.filter(
            (o) => o.name === "AlgorithmAndServers"
          );
          const foreignIndices = this.getFilterList.filter(
            (o) => o.name === "ForeignIndices"
          );
          const status = this.getFilterList.filter((o) => o.name === "Status");

          const vendorList = [{ code: -1, label: "Tümü" }];
          const platformList = [{ code: -1, label: "Tümü" }];
          const marketList = [{ code: -1, label: "Tümü" }];
          const perspectiveList = [{ code: -1, label: "Tümü" }];
          const paymentStatusList = [{ code: -1, label: "Tümü" }];
          const statusList = [{ code: -1, label: "Tümü" }];
          const researchList = [{ code: -1, label: "Tümü" }];
          const algoList = [{ code: -1, label: "Tümü" }];
          const foreignList = [{ code: -1, label: "Tümü" }];

          if (vendors.length > 0) {
            vendors[0].values.forEach((element) => {
              vendorList.push(element);
            });
            this.vendor = vendorList;
          }

          if (platforms.length > 0) {
            platforms[0].values.forEach((element) => {
              platformList.push(element);
            });
            this.platform = platformList;
          }

          if (status.length > 0) {
            status[0].values.forEach((element) => {
              statusList.push(element);
            });
            this.statu = statusList;
          }

          if (markets.length > 0) {
            markets[0].values.forEach((element) => {
              marketList.push(element);
            });
            this.marketsList = marketList;
          }

          if (perspectives.length > 0) {
            perspectives[0].values.forEach((element) => {
              perspectiveList.push(element);
            });
            this.perspectives = perspectiveList;
          }

          if (paymentStatus.length > 0) {
            paymentStatus[0].values.forEach((element) => {
              paymentStatusList.push(element);
            });
            this.paymentStatusList = paymentStatusList;
          }
          if (researchs.length > 0) {
            researchs[0].values.forEach((element) => {
              researchList.push(element);
            });
            this.researchList = researchList;
          }
          if (algorithms.length > 0) {
            algorithms[0].values.forEach((element) => {
              algoList.push(element);
            });
            this.algoList = algoList;
          }
          if (foreignIndices.length > 0) {
            foreignIndices[0].values.forEach((element) => {
              foreignList.push(element);
            });
            this.foreignList = foreignList;
          }
        }
      });
    },
    clearFilterDatas() {
      this.marketsList = [];
      this.vendor = [];
      this.statu = [];
      this.platform = [];
      this.perspectives = [];
      this.paymentStatusList = [];
      this.researchList = [];
      this.algoList = [];
      this.foreignList = [];
      this.Applications = "";
      this.PerspectiveOrVendor = "";
      this.PackageStatus = "";
      this.Platforms = "";
      this.Markets = "";
      this.PaymentStatus = "";
      this.filtered.Applications = "";
      this.filtered.PerspectiveOrVendor = "";
      this.filtered.Status = "";
      this.filtered.Platforms = "";
      this.filtered.Markets = "";
      this.filtered.PaymentStatus = "";
      this.filtered.Researchs = "";
      this.filtered.ForeignIndices = "";
      this.filtered.Algorithms = "";
      this.filtered.Branches = "";
      this.filtered.IsWinner = false;
      this.applyLowOpacityClass();
      this.setGeneralFilter({
        filter: {},
      });
    },
    hideModalFromButtons() {
      this.$modal.hide("modal");
    },
    clear() {
      this.resetDatas();
      this.setGeneralFilter({
        page: 1,
        size: 11,
        filter: {},
      });
      this.setRepresentativeReport({});
      this.key++;
    },
    clearModal() {
      this.resetDatasNoClose();
      this.setGeneralFilter({
        page: 1,
        size: 11,
        filter: {},
      });
      this.setRepresentativeReport({});
      this.key++;
    },
    resetDatas() {
      this.dateFilter = "";
      this.CustomerNo = "";
      this.CustomerName = "";
      this.DatePeriod = "";
      this.startDate = "";
      this.endDate = "";
      this.Applications = "";
      this.PerspectiveOrVendor = "";
      this.Status = "";
      this.Platforms = "";
      this.Markets = "";
      this.PackageStatus = "";
      this.PaymentStatus = "";
      this.Branch.forEach((el) => {
        el.checked = false;
      });
      this.Branch = [];
      this.Algorithms = "";
      this.Researches = "";
      this.Foreigns = "";
      this.isWinner = false;
      this.applyLowOpacityClass();
      for (let fields in this.filtered) delete this.filtered[fields];
      this.$modal.hide("modal");
    },
    resetDatasNoClose() {
      this.dateFilter = "";
      this.CustomerNo = "";
      this.CustomerName = "";
      this.DatePeriod = "";
      this.startDate = "";
      this.endDate = "";
      this.Applications = "";
      this.PerspectiveOrVendor = "";
      this.Status = "";
      this.Platforms = "";
      this.Markets = "";
      this.PackageStatus = "";
      this.PaymentStatus = "";
      this.Branch.forEach((el) => {
        el.checked = false;
      });
      this.Branch = [];
      this.Algorithms = "";
      this.Researches = "";
      this.Foreigns = "";
      this.isWinner = false;
      this.applyLowOpacityClass();
      for (let fields in this.filtered) delete this.filtered[fields];
    },
    show() {
      const formatDate = (date) => {
        const [day, month, year] = date.split("/");
        return `${year}-${month}-${day}`;
      };
      if (this.startDate != null && this.endDate != null) {
        this.DatePeriod = `${formatDate(this.startDate)}&${formatDate(
          this.endDate
        )}`;
      }

      this.filtered.CustomerNo = this.CustomerNo.toString();
      this.filtered.CustomerName = this.CustomerName;
      if (!this.DatePeriod.includes("undefined")) {
        this.filtered.DatePeriod = this.DatePeriod;
      }
      this.filtered.PaymentStatus = String(this.PaymentStatus);
      this.filtered.Researchs = String(this.Researches);
      this.filtered.Algorithms = String(this.Algorithms);
      this.filtered.ForeignIndices = String(this.Foreigns);
      this.filtered.Branches = this.Branch.map((branch) => branch.code).join(
        ","
      );

      delete this.filtered.isWinner;
      if (this.isWinner) {
        this.filtered.IsWinner = this.isWinner;
      }
      if (this.CustomerNo == "") {
        delete this.filtered.CustomerNo;
      }
      if (this.CustomerName == "") {
        delete this.filtered.CustomerName;
      }
      if (this.DatePeriod == "") {
        delete this.filtered.DatePeriod;
      }
      if (this.Applications == "" || this.Applications == "-1") {
        delete this.filtered.Applications;
      }
      if (this.PerspectiveOrVendor == "" || this.PerspectiveOrVendor == "-1") {
        delete this.filtered.PerspectiveOrVendor;
      }
      if (this.PackageStatus == "" || this.PackageStatus == "-1") {
        delete this.filtered.Status;
      }
      if (this.Platforms == "" || this.Platforms == "-1") {
        delete this.filtered.Platforms;
      }
      if (this.Markets == "" || this.Markets == "-1") {
        delete this.filtered.Markets;
      }
      if (
        this.filtered.PaymentStatus == "" ||
        this.filtered.PaymentStatus == "-1"
      ) {
        delete this.filtered.PaymentStatus;
      }
      if (this.Algorithms == -1 || this.Algorithms == "") {
        delete this.filtered.Algorithms;
      }
      if (this.Researches == -1 || this.Researches == "") {
        delete this.filtered.Researchs;
      }
      if (this.Foreigns == -1 || this.Foreigns == "") {
        delete this.filtered.ForeignIndices;
      }
      if (this.Branch == -1 || this.Branch == "") {
        delete this.filtered.Branches;
      }

      if (Object.keys(this.filtered).length === 0) {
        return this.$toast.error("Başlangıç ve bitiş tarihi seçiniz.");
      }
      this.setRepresentativeReport({
        page: { pageNumber: 1 },
      });
      this.$modal.hide("modal");

      this.setGeneralFilter({
        filter: this.filtered,
        page: 1,
      });
      this.isButtonClicked = true;

      this.dataIsLoading = true;
      this.getRepresentativeReport((response) => {
        this.dataIsLoading = false;
        this.xlsxData.data = response.data;
        if (response.error) {
          this.$toast.error(response.message);
        }
        this.isButtonClicked = false;
      });
    },
  },
  watch: {
    Markets: function (newValue) {
      if (
        this.marketsList.filter(
          (o) => o.code == newValue || o.label == newValue
        )[0] != undefined
      ) {
        const getRow = this.marketsList.filter(
          (o) => o.code == newValue || o.label == newValue
        )[0];
        this.filtered.Markets = String(getRow.code);
      }
    },
    Applications: function (newValue) {
      if (
        this.vendor.filter(
          (o) => o.code == newValue || o.label == newValue
        )[0] != undefined
      ) {
        const getRow = this.vendor.filter(
          (o) => o.code == newValue || o.label == newValue
        )[0];
        this.filtered.Applications = String(getRow.code);
      }
    },
    PerspectiveOrVendor: function (newValue) {
      if (
        this.perspectives.filter(
          (o) => o.label == newValue || o.code == newValue
        )[0] != undefined
      ) {
        const getRow = this.perspectives.filter(
          (o) => o.label == newValue || o.code == newValue
        )[0];
        this.filtered.PerspectiveOrVendor = String(getRow.code);
      }
    },
    PackageStatus: function (newValue) {
      if (
        this.statu.filter(
          (o) => o.code == newValue || o.label == newValue
        )[0] != undefined
      ) {
        const getRow = this.statu.filter(
          (o) => o.code == newValue || o.label == newValue
        )[0];
        this.filtered.Status = String(getRow.code);
      }
    },
    Platforms: function (newValue) {
      if (
        this.platform.filter(
          (o) => o.code == newValue || o.label == newValue
        )[0] != undefined
      ) {
        const getRow = this.platform.filter(
          (o) => o.code == newValue || o.label == newValue
        )[0];
        this.filtered.Platforms = String(getRow.code);
      }
    },
    Algorithms: function (newValue) {
      if (
        this.algoList.filter(
          (o) => o.code == newValue || o.label == newValue
        )[0] != undefined
      ) {
        const getRow = this.algoList.filter(
          (o) => o.code == newValue || o.label == newValue
        )[0];
        this.filtered.Algorithms = String(getRow.code);
      }
    },
    Researches: function (newValue) {
      if (
        this.researchList.filter(
          (o) => o.code == newValue || o.label == newValue
        )[0] != undefined
      ) {
        const getRow = this.researchList.filter(
          (o) => o.code == newValue || o.label == newValue
        )[0];
        this.filtered.Researchs = String(getRow.code);
      }
    },
    Foreigns: function (newValue) {
      if (
        this.foreignList.filter(
          (o) => o.code == newValue || o.label == newValue
        )[0] != undefined
      ) {
        const getRow = this.foreignList.filter(
          (o) => o.code == newValue || o.label == newValue
        )[0];
        this.filtered.ForeignIndices = String(getRow.code);
      }
    },
    Branch: function (newValue) {
      if (
        this.BranchList.filter(
          (o) => o.code == newValue || o.label == newValue
        )[0] != undefined
      ) {
        const getRow = this.BranchList.filter(
          (o) => o.code == newValue || o.label == newValue
        )[0];
        this.filtered.Branches = String(getRow.code);
      }
    },
    isWinner: function (newValue) {
      if (this.Branch.length && newValue) {
        this.Branch.forEach((el) => {
          el.checked = false;
        });
        this.Branch = [];
        delete this.filtered.Branches;
        this.filtered.IsWinner = true;
      }
      this.filtered.IsWinner = newValue;
    },
  },
  beforeMount() {
    this.setGeneralFilter({
      page: 1,
      size: 11,
      filter: {},
    });
  },
};
</script>

<style lang="scss">
.repres__reports {
  padding: 20px;

  background: #fff;
  margin: 20px;
  &-top {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 10px;
    @media (max-width: 768px) {
      flex-direction: column;
    }
    .customerNoInput {
      @media (min-width: 768px) {
        max-width: 160px;
      }
      input {
        width: 100% !important;
        box-sizing: border-box;
      }
    }

    .base-form-input.customerNoInput input,
    .form-group .mx-datepicker .mx-input,
    .form-group .base-button {
      height: 48px;
    }
    .form-group .base-button {
      font-weight: 500;
    }
  }

  .base-button {
    height: 45px;
    padding: 0 30px;
    font-size: 14px;
    &.clear-button {
      background-color: var(--color-primary-tint-40);
      color: var(--color-primary-default);
    }
  }

  .base-form-input {
    @media (max-width: 768px) {
      width: 100%;
    }
    input {
      width: 188px;
      height: 43px;
      box-shadow: none;
      border: 1px solid #ccc;
      position: relative;

      @media (max-width: 768px) {
        width: 100%;
        padding: 0px;
        box-sizing: border-box;
      }
    }

    label {
      width: max-content;
      margin-bottom: 0;
    }
  }

  .form-group {
    @media (max-width: 768px) {
      width: 100%;
    }
    .no-click {
      background-color: #555555;
      color: #fff;
      pointer-events: none;
    }
    .more {
      color: var(--color-primary-green);
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      text-decoration-line: underline;
      position: relative;
      top: -10px;
      cursor: pointer;
      @media (max-width: 768px) {
        top: auto;
        text-align: center;
      }
    }
  }

  .form-control-label,
  .base-form-input label {
    display: block;
    font-size: 12px;
    color: var(--grayscale-200);
    position: relative;
    font-weight: 500;
    margin-bottom: 5px;
  }

  .mx-datepicker {
    display: block;
    width: 131px;
    &-range {
      width: 202px;
      @media (max-width: 768px) {
        width: 100%;
      }
    }
    .mx-input {
      height: 48px !important;
    }
    @media (max-width: 768px) {
      width: 100%;
    }
  }
  .modal-body .mx-datepicker {
    width: 100%;
  }

  &-result {
    margin-top: 20px;
    position: relative;
    @media (max-width: 768px) {
      overflow-x: scroll;
    }
    &.hideAll {
      display: none;
    }
    .exportButton {
      color: var(--color-primary-green);
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px;
      text-align: right;
      margin-bottom: 20px;
      @media (min-width: 1285px) {
        position: absolute;
        top: -41.5px;
        right: 0px;
        text-align: left;
      }
      @media (max-width: 768px) {
        position: relative;
        top: 0px;
      }
    }
    table {
      border-collapse: separate;
      width: 100%;
      border: 1px solid #e8e8e8;
      border-radius: 5px;
      border-spacing: 0px;
      thead {
        tr {
          background-color: var(--grayscale-160) !important;
        }
      }
      td {
        max-width: 55px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    td,
    th {
      text-align: left;
      padding: 10.75px 3px;
      font-size: 12px;
      &:first-child {
        padding-left: 18px;
      }
    }
    tr {
      td {
        border-bottom: 1px solid var(--color-primary-tint-second);
      }
      &:last-child {
        td {
          border-bottom: 1px solid transparent;
        }
      }
    }
    tr:nth-child(even) {
      background-color: var(--color-primary-zebra);
    }
  }

  .modal {
    .vm--modal {
      width: 95% !important;
      left: 0 !important;
      margin: 0 auto;

      @media (min-width: 768px) {
        width: 680px !important;
      }
    }
    .modal-heading {
      height: 40px;
      border-bottom: 1px solid var(--grayscale-30);
      display: flex;
      align-items: center;
      padding: 10px 30px;
      justify-content: space-between;
      .close {
        margin: 5px;
        cursor: pointer;
      }
    }
    .modal-bottom {
      display: flex;
      justify-content: flex-end;
      padding: 15px 20px;
      gap: 10px;
      .base-button {
        width: 100%;
        font-size: 15px;
        font-weight: 500;
        &.giveUp {
          background: none;
          color: var(--grayscale-60);
          border: 1px solid var(--grayscale-130);
        }
      }
    }
    .modal-body {
      padding: 15px 25px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: flex-end;
      @media (max-width: 650px) {
        max-height: 300px;
        overflow-y: scroll;
      }
      .row {
        display: flex;
        width: 100%;
        margin-bottom: 20px;
        gap: 10px;
        @media (max-width: 650px) {
          flex-direction: column;
        }
        &.tripple {
          .col:first-child {
            flex: 0;
          }
        }
        .col {
          flex: 1;
          &.lowOpacity {
            opacity: 0.6;
            &.focus {
              opacity: 1;
            }
          }
          .toggleBranch {
            display: flex;
            gap: 6px;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            margin-top: 8px;
            margin-right: -14px;
            span {
              input {
                margin: 0 auto;
                width: 18px;
                height: 18px;
              }
            }
          }
          input {
            width: 100%;
            box-sizing: border-box;
            height: 48px;
            margin: 0 auto;
          }
        }
        &:last-child {
          margin-bottom: 0px;
        }
      }
      .veri-dagitim-selectbox {
        .vs__dropdown-toggle {
          min-height: 48px;
          font-size: 14px;
          padding: 0px;
        }
        .vs__selected {
          width: 140px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          height: max-content;
          position: absolute !important;
          padding-top: 12px;
          padding-left: 10px;
        }
      }
      .branch-selectbox[triplechecked="true"] {
        .vs__selected-options {
          &:after {
            content: "3 seçimden fazlası listelenmez.";
            display: block;
            width: 100%;
            position: relative;
            bottom: 0px;
          }
        }
      }
      .branch-selectbox {
        &.hasItem {
          input {
            height: 24px;
          }
        }
        .vs__selected {
          width: auto;
          overflow: visible;
          margin-right: 3px;
          position: relative !important;
          padding: 0px;
        }
        .vs__dropdown-menu {
          height: 95px;
          li {
            display: flex;
            width: 100%;
            align-items: center;
            padding: 5px;
            span {
              display: flex;
              justify-content: space-between;
              align-items: center;
              gap: 10px;
              input {
                width: auto;
                height: auto;
              }
            }
          }
        }
      }
    }
  }

  .clear-button {
    background-color: var(--color-primary-tint-40);
    color: var(--color-primary-green);
  }
  .loader {
    transform: scale(0.5);
    width: 100%;
    text-align: center;
  }
  .lds-ring {
    display: inline-block;
    position: relative;
    width: 50px;
    height: 50px;
  }
  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 8px solid #ccc;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #ccc transparent transparent transparent;
  }
  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
